import React, { memo } from 'react';
import Svg from 'react-native-svg';
import { View } from 'react-native';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import Pie from './Pie';
import { getSmartPieSlice, RADIUS } from './utils';
import { isWeb } from '../../constants';
import { rem } from '../values';
export const PIE_CHART_HEIGHT = RADIUS * 2;
const INNER_RADIUS = rem(80);
const InteractivePieChart = ({ children, pieSlices, onSelectPieSlice, selectedPieSliceKey, }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const smartSlices = getSmartPieSlice(pieSlices, onSelectPieSlice);
    return (<View style={styles.container}>
      <Svg width={PIE_CHART_HEIGHT} height={PIE_CHART_HEIGHT} viewBox={`0 0 ${PIE_CHART_HEIGHT} ${PIE_CHART_HEIGHT}`}>
        {smartSlices.map((slice, index) => (<Pie key={slice.key} theta={slice.theta} sliceKey={slice.key} finalY={slice.finalY} finalX={slice.finalX} onPress={slice.onPress} category={slice.category} hideIcon={slice.hideIcon} innerRadius={INNER_RADIUS} fill={(slice.colorKey
                ? colors.text[slice.colorKey]
                : slice.selectedColor)} labelTheta={slice.labelTheta} selected={selectedPieSliceKey} clipPathId={`${index}_clip`} polygonPoints={slice.polygonPoints}/>))}
      </Svg>
      {children ? (<View style={styles.childrenContainer} pointerEvents="none">
          <View style={styles.innerCircle}>{children}</View>
        </View>) : null}
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        alignSelf: 'center',
        width: PIE_CHART_HEIGHT,
        height: PIE_CHART_HEIGHT,
        ...(isWeb && {
            cursor: 'pointer',
        }),
    },
    childrenContainer: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
    },
    innerCircle: {
        // FIXME: shadows doesn't show on Android
        ...colors.shadows.floatingButton,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: colors.cards.onDark,
        width: INNER_RADIUS * 2,
        height: INNER_RADIUS * 2,
        borderRadius: INNER_RADIUS,
    },
}));
export default memo(InteractivePieChart);
